
// rounting
import InvoiceManageList from './invoice-manage-list/invoice-manage-list.vue';
import ApplyInvoice from './apply-invoice/apply-invoice.vue';
import InvoiceDetail from './invoice-detail/invoice-detail.vue';

export default [
  {
    path: 'list',
    name: 'InvoicemanageList',
    component: InvoiceManageList,
    meta: {
      title: '发票管理',
      breadCrumbShowIndexArr: [0]  // 面包屑
    }
  },
  {
    path: 'applyInvoice',
    name: 'applyInvoice',
    component: ApplyInvoice,
    meta: {
      title: '申请开票',
      breadCrumbShowIndexArr: [0, 1, 2]  // 面包屑
    }
  },
  {
    path: 'detail',
    name: 'invoiceDetail',
    component: InvoiceDetail,
    meta: {
      title: '详情',
      breadCrumbShowIndexArr: [0, 1, 2]  // 面包屑
    }
  }
];
